var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',_vm._l((_vm.content_controller.list),function(content,idx){return _c('div',{key:idx,staticClass:"pt-5"},[_c(_vm.getContentType(content),{tag:"component",attrs:{"content":content,"click":_vm.click}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }